import { render, staticRenderFns } from "./ProfileOverview.vue?vue&type=template&id=5e3af2d8&scoped=true&"
import script from "./ProfileOverview.vue?vue&type=script&lang=ts&"
export * from "./ProfileOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileOverview.vue?vue&type=style&index=0&id=5e3af2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3af2d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer,VTab,VTabItem,VTabs})
